import { render, staticRenderFns } from "./PopupProfileSettings.vue?vue&type=template&id=535af88a&"
import script from "./PopupProfileSettings.vue?vue&type=script&lang=js&"
export * from "./PopupProfileSettings.vue?vue&type=script&lang=js&"
import style0 from "./PopupProfileSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports